<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item url="/dashboard-default" :class="getRoute() == 'dashboard-default' ? 'active' : ''"
          navText="Métricas" v-if="user?.role == '1' || user?.role == '2'">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/dashboard" :class="getRoute() == 'operador/dashboard' ? 'active' : ''"
          navText="Métricas">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('usuarios')">
        <sidenav-item url="/users" :class="getRoute() == 'users' ? 'active' : ''" navText="Usuarios">
          <template v-slot:icon>
            <i class="fas fa-users text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('modelo')">
        <sidenav-item url="/models" :class="getRoute() == 'models' ? 'active' : ''" navText="Modelos">
          <template v-slot:icon>
            <i class="fas fa-tshirt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('produccion')">
        <sidenav-item url="/production" :class="getRoute() == 'production' ? 'active' : ''" navText="Producción">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('operaciones') || user?.role == '4'">
        <sidenav-item url="/operations" :class="getRoute() == 'operations' ? 'active' : ''" navText="Operaciones">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role == '3'">
        <sidenav-item url="/operador/tareas" :class="getRoute() == 'operador/tareas' ? 'active' : ''"
          navText="Mis Tareas">
          <template v-slot:icon>
            <i class="fas fa-tasks text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('inventario')">
        <sidenav-item url="/inventory" :class="getRoute() == 'inventory' ? 'active' : ''" navText="Inventario">
          <template v-slot:icon>
            <i class="fas fa-tshirt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('insumos')">
        <sidenav-item url="/supplies" :class="getRoute() == 'supplies' ? 'active' : ''" navText="Insumos">
          <template v-slot:icon>
            <i class="fas fa-box text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('compras')">
        <sidenav-item url="/purchases" :class="getRoute() == 'purchases' ? 'active' : ''" navText="Compras">
          <template v-slot:icon>
            <i class="fas fa-shopping-cart text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('remisiones')">
        <sidenav-item url="/remissions" :class="getRoute() == 'remissions' ? 'active' : ''" navText="Remisiones">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="showModule('nomina')">
        <sidenav-item url="/nomina" :class="getRoute() == 'nomina' ? 'active' : ''" navText="Nomina">
          <template v-slot:icon>
            <i class="fas fa-money-bill text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="chatEnabled && (user?.role == '1' || user?.role == '2')">
        <sidenav-item url="/chat-ai" :class="getRoute() == 'chat-ai' ? 'active' : ''" navText="Chat AI">
          <template v-slot:icon>
            <i class="fas fa-robot text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <sidenav-collapse
        v-if="shopifyEnabled && (user?.role == '1' || user?.role == '2')"
        collapse-id="shopifyMenu"
        nav-text="Shopify"
        route-prefix="/shopify"
        :items="shopifyMenuItems"
      >
        <template v-slot:icon>
          <i class="fab fa-shopify text-warning text-sm opacity-10"></i>
        </template>
      </sidenav-collapse>

      <sidenav-collapse
        v-if="shopifyEnabled && user?.role == '5'"
        collapse-id="shopifyMenuVendedor"
        nav-text="Shopify"
        route-prefix="/shopify"
        :items="shopifyMenuVendedorItems"
      >
        <template v-slot:icon>
          <i class="fab fa-shopify text-warning text-sm opacity-10"></i>
        </template>
      </sidenav-collapse>

      <li class="nav-item" v-if="user?.role == '1' || user?.role == '2'">
        <sidenav-item url="/settings" :class="getRoute() == 'settings' ? 'active' : ''" navText="Configuración">
          <template v-slot:icon>
            <i class="fas fa-cog text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="false">
        <sidenav-item url="/reports" :class="getRoute() == 'reports' ? 'active' : ''" navText="Informes">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


    </ul>
  </div>
  <div class="mx-3 sidenav-footer text-center mt-3">


  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";


export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
      user: {},
      shopifyMenuItems: [
        { url: "/shopify/pos", text: "POS" },
        { url: "/shopify/ordenes", text: "Órdenes" },
        { url: "/shopify/inventario", text: "Inventario" },
      ],
      shopifyMenuVendedorItems: [
        { url: "/shopify/pos", text: "POS" },
        { url: "/shopify/ordenes", text: "Órdenes" },
        { url: "/shopify/inventario", text: "Inventario" },
      ],
    };
  },
  components: {
    SidenavItem,
    SidenavCollapse,
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    console.log(user);
    if (user) {
      this.user = user;
    }
    this.loadSettings();
  },
  computed: {
    chatEnabled() {
      return this.$store.getters["settings/chatEnabled"];
    },
    shopifyEnabled() {
      return this.$store.getters["settings/shopifyEnabled"];
    },
  },
  methods: {
    /** Si el usuario es supervisor (role 2), solo muestra el ítem si tiene el módulo activo en supervisor_modules. Si es admin (role 1) u otro, muestra según la regla original. */
    showModule(moduleKey) {
      if (!this.user) return false;
      const role = this.user.role;
      // Administrador: ve todo (usuarios, modelo, produccion, operaciones, inventario, insumos, compras, remisiones, nomina)
      if (role === '1' || role === 1) return true;
      // Supervisor: solo si tiene el módulo en supervisor_modules
      if (role === '2' || role === 2) {
        const mods = Array.isArray(this.user.supervisor_modules)
          ? this.user.supervisor_modules
          : (typeof this.user.supervisor_modules === 'string' ? (this.user.supervisor_modules ? JSON.parse(this.user.supervisor_modules) : []) : []);
        return mods && mods.includes(moduleKey);
      }
      return false;
    },
    getRoute() {
      const path = this.$route.path;
      // Si la ruta es de operador, devolver la ruta completa sin la barra inicial
      if (path.startsWith('/operador/')) {
        return path.substring(1); // Remover la barra inicial: '/operador/dashboard' -> 'operador/dashboard'
      }
      if (path.startsWith('/shopify/')) {
        return path.substring(1);
      }
      // Para otras rutas, devolver solo la primera parte
      const routeArr = path.split("/");
      return routeArr[1] || '';
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },
    async loadSettings() {
      try {
        await this.$store.dispatch("settings/get");
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
      }
    },

  },
};
</script>
